import { render, staticRenderFns } from "./ubicaciones-empresa.vue?vue&type=template&id=754f9efc&scoped=true"
import script from "./ubicaciones-empresa.vue?vue&type=script&lang=js"
export * from "./ubicaciones-empresa.vue?vue&type=script&lang=js"
import style0 from "./ubicaciones-empresa.vue?vue&type=style&index=0&id=754f9efc&prod&scoped=true&lang=css"
import style1 from "./ubicaciones-empresa.vue?vue&type=style&index=1&id=754f9efc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754f9efc",
  null
  
)

export default component.exports